import { useQuery } from "@tanstack/react-query";

import { apiGet } from "~/shared/api/client";

export interface RuntimeConfigDto {
    staleJobsImageTimeoutMinutes: number;
    staleJobsVideoTimeoutMinutes: number;
}

const runtimeConfigKey = ["system", "runtime-config"] as const;

export function useRuntimeConfig() {
    return useQuery({
        queryKey: runtimeConfigKey,
        queryFn: () => apiGet<RuntimeConfigDto>("/v2/system/runtime-config"),
        staleTime: Number.POSITIVE_INFINITY,
        gcTime: Number.POSITIVE_INFINITY,
    });
}
